module.exports = __webpack_public_path__ + "img/lvyou299.e94af4d6.png";